export enum LazyLibURL {
  html2canvas = 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.3.3/html2canvas.min.js',
  jspdf = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.4.0/jspdf.umd.min.js',
  xlsx = 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.17.2/xlsx.full.min.js',
  zenDesk = 'https://static.zdassets.com/ekr/snippet.js',
  tableau = 'https://prod-uk-a.online.tableau.com/javascripts/api/tableau.embedding.3.latest.min.js',
}
